import { getMembersBaseUrl } from "@utils/getMembersBaseUrl";
import { setupAPIClient } from "./api";
const baseURL = process.env.NEXT_PUBLIC_MEMBERS_BACKEND_URL;

const pathname = typeof window !== "undefined" ? window.location.pathname : "";
const membersBaseUrl = getMembersBaseUrl(pathname);

export const coursesApi = setupAPIClient(baseURL);
export const membersApi = setupAPIClient(membersBaseUrl);
